import { get, post } from '@/base/http-base.js'
//展会服务-列表
export function getDescribeContentListApi(params) {
  return get('/mh5-api/v1/web/cms/content/describeContentList', params)
}
//展会服务-详情
export function getDescribeContentApi(params) {
  return get('/mh5-api/v1/web/cms/content/describeContent', params)
}
//展会介绍
export function getIntroductionApi(params) {
  return get('/mh5-api/v1/web/cms/content/introduction', params)
}
//展区图册-nav
export function getExhibitionInfosApi(params) {
  return get('/mh5-api/api/picture/exhibitionInfos', params)
}
//展区图册-列表
export function getDescribePicturesApi(params) {
  return get('/mh5-api/api/picture/describePictures', params)
}
//展商名录
export function getAccountIndustryListApi(params) {
  return get('/idaas-api/getAccountIndustryList', params)
}
//展商名录-搜索
export function getAccountListApi(params) {
  return get('/idaas-api/getAccountList', params)
}
//展商名录-搜索-new
export function getExhibitorList(params) {
  // return get('/getAccountListWithFields', params)
  return post('/basic-api/api/v1/exhibitorDirectory/list', params)
}
//展商名录-详情
export function getExhibitorDetail(enterpriseId) {
  // return get('/getAccount', params)
  return get(
    `/basic-api/api/v1/exhibitorDirectory/detail/${enterpriseId}`
  )
}
//展商客服
export function getAccountUserListApi(params) {
  return get('/basic-api/v1/compatible/getAccountUserList', params)
}
//展商名录分类
export function getIndustryClass(params) {
  return get('/basic-api/api/v1/category', params)
}
//展商名录分类
export function getIndustryClassTree(params) {
  return get('/basic-api/api/v1/category/forest/INDUSTRY', params)
}
//user信息
export function getAccountUserApi(params) {
  return get('/idaas-api/getAccountUser', params)
}
//获取店铺列表
export function getShopList(params) {
  return post('/2d-api/open/api/shoplist', params)
}
// 站内信列表列表
export function getMessageList(params) {
  return get('/mh5-api/v1/website/notice/infos', params)
}
// 站内信列表详情
export function getMessageDetail(params) {
  return get('/mh5-api/v1/website/notice/detail/' + params.id, params)
}
// 批量删除站内信
export function messageDelete(params) {
  return post('/mh5-api/v1/website/notice/batchDelete', params)
}
// 批量已读站内信
export function messageRead(params) {
  return post('/mh5-api/v1/website/notice/batchRead', params)
}
